import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { isPaymentCollectionsReconciliationRequest } from '@core/reconciliation-api-url';
import { LoaderService } from '../services/loader.service';
import { environment } from '../../../environments/environment';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  // GoSkaler API solo se usa para traer el listado DIAN, que tarda minutos y tiene su propio estado en el modal.
  if (isPaymentCollectionsReconciliationRequest(req.url) || req.url.startsWith(environment.goskalerApiUrl)) {
    return next(req);
  }

  const loaderService = inject(LoaderService);
  
  // Show the loader when the request starts
  loaderService.show();

  return next(req).pipe(
    // Hide the loader when the request completes (success or error)
    finalize(() => {
      loaderService.hide();
    })
  );
};
